
import React, { useEffect, useState } from "react";
import { isEqual } from "lodash";
import FiltersBar from "components/FiltersBar";

const RenoCommFilters = React.memo(({
    allModels,
    setFilteredModels,
    locationOpts,
    userOpts,
    modelOpts,
}) => {
    // Flag to determine if filters were updated
    const [newFilter, setNewFilter] = useState(false);
    const [initialFilters, setInitialFilters] = useState({});

    // List of selected filters
    const [selectedLocs, setSelectedLocs] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedModels, setSelectedModels] = useState([]);

    // Clear filters
    const handleClear = () => {
        // Select all filter options
        setSelectedLocs(initialFilters.locations);
        setSelectedUsers(initialFilters.users);
        setSelectedModels(initialFilters.models);

        // Reset filtered models list and disable apply button
        setFilteredModels(allModels);
        setNewFilter(false);
    };

    // Apply filters
    const handleApply = () => {
        const filteredData = allModels.filter(([key, model]) => {
            const selectedUserNames = userOpts
                .filter((opt) => selectedUsers.includes(opt.value))
                .map((opt) => opt.label);
            const matchLocation = selectedLocs.includes(model.provTerr);
            const matchUser = selectedUserNames.includes(model.userName);
            const matchModel = selectedModels.includes(key);
            return matchLocation && matchUser && matchModel;
        });

        // Update filtered models list and disable button after applying
        setFilteredModels(filteredData);
        setNewFilter(false);
    };

    // Update selected filter lists
    const handleChange = (type, value) => {
        if (type === "location") setSelectedLocs(value);
        else if (type === "user") setSelectedUsers(value);
        else if (type === "model") setSelectedModels(value);

        setNewFilter(true);
    };

    useEffect(() => {
        const initLocations = locationOpts.map((opt) => opt.value);
        const initUsers = userOpts.map((opt) => opt.value);
        const initModels = modelOpts.map((opt) => opt.value);

        setInitialFilters({
            locations: initLocations,
            users: initUsers,
            models: initModels,
        });
        
        setSelectedLocs(initLocations);
        setSelectedUsers(initUsers);
        setSelectedModels(initModels);
    }, [locationOpts, userOpts, modelOpts]);

    return (
        <FiltersBar
            multiSelectInputs={[
                {
                    label: "Location",
                    options: locationOpts,
                    selectedOpts: selectedLocs,
                    handleOptChange: (value) => handleChange("location", value),
                },
                {
                    label: "User",
                    options: userOpts,
                    selectedOpts: selectedUsers,
                    handleOptChange: (value) => handleChange("user", value),
                },
                {
                    label: "Models",
                    options: modelOpts,
                    selectedOpts: selectedModels,
                    handleOptChange: (value) => handleChange("model", value),
                }
            ]}
            handleApply={handleApply}
            handleClear={handleClear}
            newFilter={newFilter}
        />
    );
}, isEqual);

export default RenoCommFilters;